import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send, Loader2 } from 'lucide-react';

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState('idle'); 

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({ ...prevState, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus('idle');

        await new Promise((resolve) => setTimeout(resolve, 2000));

        console.log('Form submitted:', formData);

        setIsSubmitting(false);
        setSubmitStatus('success');
        setFormData({ name: '', email: '', message: '' });

        setTimeout(() => setSubmitStatus('idle'), 3000);
    };

    return (
        <div className="container mx-auto px-6 py-12">
            <h1 className="text-4xl font-bold mb-8 text-center gradient-text">Contact Us</h1>

            <div className="grid md:grid-cols-2 gap-12">
                <div className="card p-8">
                    <h2 className="text-2xl font-semibold mb-6 gradient-text">Get in Touch</h2>
                    <p className="text-gray-600 mb-6">
                        Have questions about TweetInsight? We're here to help. Reach out to us using the contact information below or fill out the form, and we'll get back to you as soon as possible.
                    </p>
                    <div className="space-y-4">
                        <div className="flex items-center group">
                            <Mail className="w-6 h-6 text-indigo-600 mr-2 group-hover:animate-bounce" />
                            <span className="text-gray-600">baramhana10@gmail.com</span>
                        </div>
                        <div className="flex items-center group">
                            <Phone className="w-6 h-6 text-indigo-600 mr-2 group-hover:animate-bounce" />
                            <span className="text-gray-600">+970592600262</span>
                        </div>
                        <div className="flex items-center group">
                            <MapPin className="w-6 h-6 text-indigo-600 mr-2 group-hover:animate-bounce" />
                            <span className="text-gray-600">Palestine - Nablus</span>
                        </div>
                    </div>
                </div>

                <div className="card p-8">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-300"
                            />
                        </div>
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-300"
                            />
                        </div>
                        <div>
                            <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                            <textarea
                                id="message"
                                name="message"
                                rows={4}
                                value={formData.message}
                                onChange={handleChange}
                                required
                                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-300"
                            ></textarea>
                        </div>
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="button w-full flex justify-center items-center"
                        >
                            {isSubmitting ? (
                                <Loader2 className="animate-spin mr-2" />
                            ) : (
                                <Send className="mr-2" />
                            )}
                            {isSubmitting ? 'Sending...' : 'Send Message'}
                        </button>
                        {submitStatus === 'success' && (
                            <p className="text-green-600 text-center">Message sent successfully!</p>
                        )}
                        {submitStatus === 'error' && (
                            <p className="text-red-600 text-center">An error occurred. Please try again.</p>
                        )}
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Contact;
